import ClusterHubPage from '../../components/ClusterHubPage';
import { CLUSTERS } from '../../data/clusterConfig';
export default function AnksiyeteTestleriHub() {
  return <ClusterHubPage cluster={CLUSTERS['anksiyete-testleri']} />;
}
